export class EmployeeListQueryModel {
    companySurrKey: number;
    limit: number;
    page: number;
    query: string;
}

export class EmployeeListModel {
    totalCount: number;
    list: Array<EmployeeModel>;
}

export class EmployeeModel {
    status: number;
    jobFunction: number;
    employeeSurrKey: number;
    userAvatar: string;
    fullName: string;
}